import React from 'react';
import AddPostForm from './forms/AddPostForm';

const AddPost = () => {
  return <AddPostForm />;
};

export default AddPost;
